// extracted by mini-css-extract-plugin
export default {"root":"mtPu1BAApp","header":"KXweRP1Czn"};